import type { PartnerStatus } from "@redotech/admin-sdk/rpc/schema/partners/shared";
import PlusIcon from "@redotech/redo-icons/plus.svg";
import SearchIcon from "@redotech/redo-icons/search-sm.svg";
import { RedoButton } from "@redotech/redo-web/arbiter-components/buttons/redo-button";
import { RedoButtonTabGroup } from "@redotech/redo-web/arbiter-components/checkbox/redo-button-tab-group";
import { Flex } from "@redotech/redo-web/flex";
import { memo } from "react";

// Reuse the merchants listing page's toolbar styling so the partners
// list reads as the same surface as `/onboardings/all/merchants`.
import * as styles from "../../onboardings/returns/returns-page.module.css";

export type StatusFilter = PartnerStatus | "all";

interface PartnersListingToolbarProps {
  searchQuery: string;
  onSearchChange: (value: string) => void;
  statusFilter: StatusFilter;
  onStatusFilterChange: (status: StatusFilter) => void;
  onCreateClick: () => void;
}

const STATUS_FILTER_OPTIONS: { value: StatusFilter; el: string }[] = [
  { value: "all", el: "All" },
  { value: "active", el: "Active" },
  { value: "paused", el: "Paused" },
  { value: "terminated", el: "Terminated" },
];

export const PartnersListingToolbar = memo(function PartnersListingToolbar({
  searchQuery,
  onSearchChange,
  statusFilter,
  onStatusFilterChange,
  onCreateClick,
}: PartnersListingToolbarProps) {
  return (
    <div className={styles.filterButtons}>
      <Flex
        align="center"
        aria-label="Status"
        gap="none"
        role="group"
        shrink={0}
        w="fit-content"
      >
        <RedoButtonTabGroup
          fullWidth={false}
          onChange={onStatusFilterChange}
          options={STATUS_FILTER_OPTIONS}
          size="sm"
          value={statusFilter}
        />
      </Flex>
      <div className={styles.merchantSearchContainer}>
        <SearchIcon
          aria-hidden
          className={styles.merchantSearchIcon}
          height={16}
          width={16}
        />
        {/* design-allow: matches the merchants listing search field this toolbar reuses */}
        <input
          className={styles.merchantSearchInput}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder="Search by email, name, or referral code"
          type="text"
          value={searchQuery}
        />
      </div>
      <div className={styles.toolbarEndActions}>
        <RedoButton
          hierarchy="primary"
          IconLeading={PlusIcon}
          onClick={onCreateClick}
          size="sm"
          text="Create partner"
        />
      </div>
    </div>
  );
});
